export enum TdFormEvents {
  PageView = 'TD GIC Form - Page View',
  SubmissionErrored = 'TD GIC Form - Submission Errored',
  SubmissionCompleted = 'TD GIC Form - Submission Completed',
}
